import React, {ChangeEvent, useState} from "react";
import {Button} from "@mui/material";
import {UploadFile} from "@mui/icons-material";
import axios from "axios";


export default function SheetsUpload() {
    const [filename, setFilename] = useState("");

    const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) {
            return;
        }
        const file = e.target.files[0];
        let subData = new FormData();
        subData.append('sheets', file)

        axios.post('/api/characters', subData, {headers: {"Content-Type": "multipart/form-data"}}).then((data) => {
            console.log(data);
        }, (data) => {
            console.log("ERROR")
            console.log(data)
        })
    };

    return <React.Fragment> <Button
        component="label"
        variant="outlined"
        startIcon={<UploadFile/>}
        sx={{marginRight: "1rem"}}
    >
        Upload PDF
        <input type="file" accept=".pdf" hidden onChange={handleFileUpload}/>
    </Button></React.Fragment>

}